module.exports = __webpack_public_path__ + "img/Huesca.ef1db073.png";